import { API } from "@network";
import { API_COMPANY_ALL } from "@network/URL";

export const getCompanyList = (body?: any) => {
  return API.post(API_COMPANY_ALL, body);
};
